import React from "react";

import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";

import checksuccess from "views/job-details/img/checksuccess.png";
import offerletter from "views/profile/img/offerletter.png";
class JobRejectPopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isSuccess: false };
    // console.log(props.showRefer);
  }
  render() {
    return (
      <>
        <Modal
          center
          open={this.props.showReject}
          onClose={this.props.onclose}
          classNames={{
            modal: "modal-w900px",
          }}
        >
          <div className="refer-modal lg:p-4 md:p-4 ">
            {!this.state.isSuccess && (
              <div>
                <div>
                  <h2 className="refer-h2 uppercase fsize22 sm-fsize16">
                    JOB OFFER
                  </h2>
                </div>
                <div className="text-center">
                  <div>
                    <div className="lg:px-4 md:px-4">
                      <div className="lg:flex md:flex justify-center items-center m-auto ">
                        <div className="lg:w-2/5 md:w-2/5 w-full">
                          <div className="joboffer-img-w290">
                            <p className="fsize16 text-black text-left  mb-4">
                              You have{" "}
                              <span className="textF43800">Rejected</span> the
                              Job Offer!
                            </p>
                            <img
                              src={offerletter}
                              alt="offerletter"
                              className="rounded-lg joboffer-img-h210"
                            />
                            <p className="underline text-white fsize20 font-bold  cursor-pointer ">
                              View Offer Letter
                            </p>
                          </div>
                        </div>
                        <div className="lg:w-3/5 md:w-3/5 w-full lg:px-8 md:px-8">
                          <div class="form-group  modal-form-cs text-left  w-full">
                            <label for="">Reason for Rejecting</label>
                            <select className="select-dropdown-c fsize15">
                              <option value="" disabled>
                                Select
                              </option>
                              <option value="">Not in desired location</option>
                              <option value="">Not in desired location</option>
                            </select>
                          </div>
                          <div class="form-group pt-6  modal-form-cs   ">
                            <input
                              type="text"
                              placeholder=""
                              className="h-107px input-b4rem fsize16"
                              value="Remarks if any.."
                            />
                          </div>
                        </div>
                      </div>
                      <div className="sm-w-full md:mt-0 lg:mt-0 mt-6  text-right">
                        <button className="filled-button uppercase sm-fsize14 sm-w-full rounded-25px  fsize16 font-bold w-200px h-50px  lg:ml-3 md:ml-3">
                          SUBMIT
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {this.state.isSuccess && (
              <div>
                <img src={checksuccess} className="m-auto" />
                <h1 className="fsize18 text-center font-bold line-h25 mt-4">
                  Referral Success
                </h1>
                <div class="w-full fixed-btn lg:mt-16 md:mt-16 mt-6">
                  <a
                    class="btn btn-orange-otp btn-otp-wauto mx-auto myBtn"
                    href="#"
                  >
                    REFER ANOTHER FRIEND
                  </a>
                </div>
              </div>
            )}
          </div>
        </Modal>
      </>
    );
  }
}

export default JobRejectPopup;
